<div class="db-range-panel">
    <div class="db-range-panel__btns">
        <h2 class="mb17">{{ 'text_presets' | dbText }}</h2>
        <button
                mat-button
                *ngFor="let item of customPresets"
                color="primary"
                style="width: 100%; text-align: left;"
                [ngClass]="{'active': item === activeRange}"
                (click)="selectRange(item)"
                [class.preset]="item == selectedRange"
        >
            {{ getPresetLabel(item) }}
        </button>
    </div>
    <div class="compare-date-range">
        <h3>{{ 'text_compareToPrevious' | dbText }}</h3>
        <div class="compare-date-range__switcher mt10">
            <button class="period"
                    [ngClass]="{'active': activeSwitcher === 'period'}"
                    (click)="switchPeriod('period')">{{ 'text_period' | dbText }}</button>
            <button class="year"
                    [ngClass]="{'active': activeSwitcher === 'year'}"
                    (click)="switchPeriod('year')">{{ 'text_year' | dbText }}</button>
        </div>
    </div>
    <!-- </mat-card> -->
</div>
